<template>
    <div v-if="showUpgradeSelector || showLanguageSelector">
        <div class="soft-language">
            <div class="row" v-if="showUpgradeSelector">
                <div class="col-lg-5 col-md-12">
                    <div class="soft-language__title">
                        {{ getTranslation('software-languages-vue', 'choose_customer_type') }}
                        <a
                            class="popover-item"
                            href="#"
                            tabindex="0"
                            v-b-popover.hover="{content: getTranslation('software-languages-vue', 'choose_customer_type_help'), html: true, placement: 'bottom'}"
                        >
                            <span>?</span>
                        </a>
                    </div>
                </div>
                <div class="col-lg-7 col-sm-12">
                    <select2
                        class="form-control" data-width="100%"
                        data-minimum-results-for-search="Infinity"
                        :value="forceUserType"
                        @input="setForceUserType($event)"
                        name="forceUserType"
                        data-theme="bootstrap4"
                    >
                        <option
                            v-for="(val, key) in canUpgradeUserTypes" :value="val"
                        >
                            {{ getTranslation('user-types', 'select_user_type_' + val) }}

                        </option>
                    </select2>
                </div>
            </div>
            <br>
            <div class="row" v-if="showLanguageSelector">
                <div class="col-lg-5 col-md-12">
                    <div class="soft-language__title">
                        {{ getTranslation('software-languages-vue', 'software_language') }}
                        <a
                            class="popover-item"
                            href="#"
                            tabindex="0"
                            v-b-popover.hover="{content: getTranslation('software-languages-vue', 'software_language_help'), html: true, placement: 'bottom'}"
                        >
                            <span>?</span>
                        </a>
                    </div>
                </div>
                <div class="col-lg-7 col-sm-12">
                    <select2
                        class="soft-language__select form-control" data-width="100%" data-placeholder="Select program language"
                        data-minimum-results-for-search="Infinity"
                        :value="selectedLanguage"
                        @input="setSoftwareLanguage($event)"
                        name="program_language_id"
                        data-theme="bootstrap4"
                    >
                        <option
                            v-for="(language, code) in sortedLanguages" :value="language[0]"
                        >
                            {{ language[1] }}
                        </option>
                    </select2>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        methods: {
            setSoftwareLanguage(selected) {
                let self = this;
                let softwareLanguages = {};

                Object.keys(this.productLanguages).forEach(function (item) {
                    self.$store.commit('removeAdditionalLanguageToCart', {selected: selected, product: item});
                    if (self.productLanguages[item]['items'].hasOwnProperty(selected)) {
                        softwareLanguages[item] = selected;
                    } else {
                        softwareLanguages[item] = self.defaultReportLanguage;
                    }
                });

                //remove this language from program languages
                if (!_.isNil(this.$store.state.cart.programLanguages)) {
                    _.forOwn(this.$store.state.cart.programLanguages, function(pr, key) {
                        if (!_.isNil(pr.languages[selected])) {
                            let newLanguages = _.omit(pr.languages, [selected]);
                            self.$store.commit('addProgramLanguages', {
                                id: pr.id,
                                languages: newLanguages,
                                product: pr.product
                            });
                        }
                    });
                }

                this.$store.commit('setSoftwareLanguages', {languages: softwareLanguages});
                this.resetCartStep();
            },
            resetCartStep() {
                let payload = {'step': 1};
                this.$store.commit('setCartStep', payload);
                this.$store.commit('setMustConfirm', 1);
            },
            setForceUserType(selected) {
                this.forceUserType = selected;
                this.$store.commit('changeUserLevel', this.forceUserType);
                this.$store.commit('setForcedUserType', this.forceUserType);
                this.resetCartStep();
            }
        },
        computed: {
            selectedLanguage() {
                if (this.$store.state.cart.softwareLanguage.hasOwnProperty(1)) {
                    return this.$store.state.cart.softwareLanguage[1];
                }
                return this.defaultReportLanguage;
            },
            sortedLanguages() {
                let self= this;
                return Object.entries(this.languages)
                    .sort(function (a, b) {
                        return a[1].localeCompare(b[1], self.currentLocale);
                    });
            }
        },
        beforeMount() {

            if (
                (this.$store.state.cart.existingUserLevel === 'business' ||
                this.$store.state.cart.existingUserLevel === 'truss4') &&
                this.$store.state.cart.loggedInUser
            ) {
                let index = this.canUpgradeUserTypes.indexOf('personal');
                if (index > -1) {
                    this.canUpgradeUserTypes.splice(index, 1);
                }
            }
        },
        mounted() {
            if (this.$store.state.cart.forceUserLevel !== 'personal') {
                this.forceUserType = this.$store.state.cart.forceUserLevel;
            }
            if (this.$store.state.cart.forceUserLevel === 'truss4') {
                this.forceUserType = 'business';
            }
            if (this.$store.state.cart.loggedInUser > 0) {
                this.showLanguageSelector = false;
            }

            this.showUpgradeSelector = false;

            if (
                this.$store.state.cart.existingUserLevel === 'personal' ||
                this.$store.state.cart.existingUserLevel === 'business' ||
                this.$store.state.cart.existingUserLevel === ''
            ) {
                this.showUpgradeSelector = true;
            }

        },
        data() {
            return {
                languages: window.jsonLanguages[1].items,
                productLanguages: window.jsonLanguages,
                defaultReportLanguage: 'en',
                currentLocale: window.shopConfigOptions.language,
                canUpgradeUserTypes: window.canUpgradeUserTypes,
                forceUserType: 'personal',
                showLanguageSelector: true,
                showUpgradeSelector: true,
            };
        }
    }
</script>

<style>
    .popover-item {
        text-decoration: none;
        height: 26px;
        width: 26px;
        border: 1px #c4c9cd solid;
        border-radius: 50%;
        padding-left: 2px;
        padding-bottom: 3px;
        display: inline-flex;
        margin-left: 3px;
    }
    .popover-item:hover {
        text-decoration: none;
    }
    .popover-item span {
        padding-left: 6px;
        padding-right: 8px;
        color: #c4c9cd;
        text-align: center;
        line-height: 2.8rem;
        font-size: 1.6rem;
        font-weight: 300;
    }
    .popover {
        max-width: 600px;
        padding:10px;
    }
</style>
